<template>
  <div class="flex flex-col ingredient-wrap">
    <span class="text-left">{{ label }}</span>
    <div class="flex flex-col ">
      <div
          class="flex flex-row items-center mt-2"
          v-for="(item, index) in ingredientValue"
          :key="item.id"
      >
        <DropdownSelect
            :place-holder="placeHolderChoose"
            :disabled="item.id === -1000"
            :show-error="item.showSelectError"
            class="flex-1"
            :value="item.text"
            @input="
            (selectedItem, optionIndex) =>
              onIngredientChange(index, optionIndex, selectedItem)
          "
            :options="ingredientOptions"
        />
        <div class="ingredient-percent">
          <van-field
              :disabled="item.id === -1000"
              :value="item.value"
              :style="{
              '--fieldBorderColor': item.showInputError ? 'red' : '#e8e8e8'
            }"
              placeholder="percent"
              type="number"
              @input="e => onPercentValueChange(e, index)"
              @blur="onBlur(index)"
              @focus="onFocus(index)"
          />
          <span>%</span>
        </div>
        <div v-if="item.id !== -1000" style="width:34px;height:34px;text-align: center;border:1px solid #E8E8E8;border-radius: 8px;margin-left:8px" @click="onIngredientDelete">-</div>
      </div>
      <!--  v-if="ingredientOptions.length > 0"  -->
      <div
          class="radius-border flex flex-row items-center justify-center mt-3 h-8"
          @click="onItemAddClick"
      >
        <span class="third-color">+</span>
      </div>
    </div>
  </div>
</template>

<script>
import DropdownSelect from "@/components/DropdownSelect";
import log from "@/util/log";

export default {
  name: "IngredientsEditor",
  components: { DropdownSelect },
  props: {
    label: {
      type: String,
      default: ""
    },
    ingredientValue: {
      type: Array,
      default: () => {
        return [{ text: "", value: 0 }];
      }
    },
    ingredientOptions: {
      type: Array,
      default: () => {
        return [{ text: "THC", value: 0 }];
      }
    },
    idleIngredient: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {};
  },
  methods: {
    onIngredientDelete(index, optionIndex, selectedItem) {
      this.$emit("onItemDelete", this.lowerKey, index, optionIndex, selectedItem);
    },
    onIngredientChange(index, optionIndex, selectedItem) {
      log(
          `index = ${index}, selectedIndex = ${optionIndex} , item = ${JSON.stringify(
              selectedItem
          )}`
      );
      this.$emit("onItemChange", this.lowerKey, index, optionIndex, selectedItem);
      // this.ingredientSelect[index].value = e;
    },
    onItemAddClick() {
      this.$emit("onItemAdd", this.lowerKey);
    },
    onPercentValueChange(e, index) {
      if (e == "") {
        this.$emit("onPercentValueChange", this.lowerKey, "", index);
        return;
      }
      if (this.idleIngredient === 0) {
        inputValue = inputValue.replace(/^(\d+)\.(\d).*$/, "$1.$2");
        this.$emit("onPercentValueChange", this.lowerKey, inputValue, index);
        return;
      }
      // 使用正则表达式去除非数字和小数点以外的字符
      let inputValue = e.replace(/[^0-9.]/g, "");
      // 使用正则表达式确保小数点只能出现一次，并保留一位小数
      inputValue = inputValue.replace(/^(\d+)\.(\d).*$/, "$1.$2");
      if (inputValue >= this.idleIngredient) {
        inputValue = this.idleIngredient;
      }
      // 更新数据模型
      this.$emit("onPercentValueChange", this.lowerKey, inputValue, index);
    },
    onBlur(index) {
      this.$emit("onBlur", this.lowerKey, index);
    },
    onFocus(index) {
      this.$emit("onFocus", this.lowerKey, index);
    }
  },

  computed: {
    lowerKey() {
      return this.label.toLowerCase();
    },
    placeHolderChoose() {
      if (this.lowerKey === "ingredients") {
        return "Choose Ingredients";
      }
      return "Choose Terpenes";
    }
  },

  async mounted() {
  }
};
</script>

<style scoped lang="less">
.ingredient-wrap {
  background: white;
  border-radius: 12px;
}

.ingredient-percent {
  width: 85px;
  margin-left: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 10px;
  padding: 1px 4px;
  font-size: 14px;
  border: 1px solid #e8e8e8;


  ::v-deep .van-field {
    padding: 0;

    .van-field__value {
    }

    .van-field__body {
      text-align: center;

      .van-field__control {
        padding-left: 0;
        padding-right: 0;
      }

      input {
        padding-left: 0 !important;
        padding-right: 0 !important;;
        text-align: center !important;;
        font-size: 14px !important;;
      }
    }

    .van-field__control {
      height: 32px;
    }

    .van-ellipsis {
      font-size: 14px;
    }
  }


  //&::after {
  //  position: absolute;
  //  content: "%";
  //  right: 10px;
  //  top: 50%;
  //  transform: translateY(-50%);
  //}
}
</style>
